module.exports = __webpack_public_path__ + "static/media/btn_android_ja.7ad69d28.png";